<!--
  Sitzt in der Kachel über der Fußzeile. Der eigene Klick-Stopper verhindert,
  dass ein Klick auf einen der Knöpfe zugleich als "Kachel öffnen" gilt.
-->
<div class="kachel-offline" (click)="$event.stopPropagation()">

  <!-- NOCH NICHT HERUNTERGELADEN -->
  <button
    mat-stroked-button
    type="button"
    class="offline-button"
    *ngIf="!istVerfuegbar && !seiteIstOffline"
    [disabled]="laeuft"
    (click)="verfuegbarMachen($event)"
    matTooltip="Alle Messstellen, Kategorien und Prüfpunkte auf dieses Gerät laden">

    <mat-spinner *ngIf="laeuft" diameter="16"></mat-spinner>
    <mat-icon *ngIf="!laeuft">cloud_download</mat-icon>
    Offline verfügbar machen
  </button>


  <!--
    Ohne Verbindung und ohne lokalen Bestand gibt es hier nichts zu tun –
    aber der Hinweis erklärt, warum der Knopf fehlt.
  -->
  <span class="offline-nicht-moeglich" *ngIf="!istVerfuegbar && seiteIstOffline">
    <mat-icon inline>cloud_off</mat-icon>
    Nicht offline verfügbar
  </span>


  <!-- BEREITS HERUNTERGELADEN -->
  <ng-container *ngIf="istVerfuegbar">

    <div class="offline-status">
      <mat-icon class="offline-ok">offline_pin</mat-icon>
      <span class="offline-titel">Offline verfügbar</span>
    </div>

    <div class="offline-zeilen">
      <span>
        Stand: {{ status?.downloadedAtUtc | date:'dd.MM.yyyy HH:mm' }}
      </span>

      <span *ngIf="status?.lastSyncAtUtc">
        Letzte Synchronisierung:
        {{ status?.lastSyncAtUtc | date:'dd.MM.yyyy HH:mm' }}
      </span>

      <!-- Die wichtigste Zahl im Block: ist die Arbeit schon beim Server? -->
      <span class="offline-ausstehend" *ngIf="offen > 0">
        <mat-icon inline>sync_problem</mat-icon>
        {{ offen }} {{ offen === 1 ? 'Änderung' : 'Änderungen' }} ausstehend
      </span>
    </div>

    <div class="offline-aktionen">
      <button
        mat-button
        type="button"
        [disabled]="laeuft || seiteIstOffline"
        (click)="aktualisieren($event)"
        matTooltip="Erst ausstehende Änderungen senden, danach den aktuellen Serverstand laden">
        <mat-icon>sync</mat-icon>
        Aktualisieren
      </button>

      <button
        mat-button
        color="warn"
        type="button"
        [disabled]="laeuft"
        (click)="entfernen($event)"
        matTooltip="Lokale Kopie löschen. Nur möglich, wenn alles synchronisiert ist">
        <mat-icon>delete_sweep</mat-icon>
        Entfernen
      </button>
    </div>

  </ng-container>

</div>
